<template>
  <div class="circle-btn">
    <slot />
  </div>
</template>

<script>
export default {
  computed: {},
};
</script>

<style lang="scss" scoped>
.circle-btn {
  position: relative;
  height: 60px;
  width: 60px;
  border-radius: 50%;
  background-color: var(--custom-color1);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 16px;
  transition: 0.3s;
  &:hover {
    opacity: 0.8;
  }
}
</style>
